import { Overline, Reveal } from "./Reveal";

const STEPS = [
  { n: "01", title: "Consult & Colour", desc: "We walk the space, listen, and build a palette with physical swatches under your actual light — never screen guesses." },
  { n: "02", title: "Prepare Obsessively", desc: "Fill, sand, caulk, mask, prime. The finish you admire is decided long before a paint tin is opened." },
  { n: "03", title: "Apply with Precision", desc: "Premium coatings, lines cut by hand, sprayed or rolled to suit the surface — never the schedule." },
  { n: "04", title: "Inspect & Hand Over", desc: "A daylight walkthrough together. We leave only when every line earns the Strovyn name." },
];

const STATS = [
  { value: "480+", label: "Projects completed" },
  { value: "5yr", label: "Workmanship warranty" },
];

export default function ManifestoSection() {
  return (
    <section id="manifesto" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 sm:py-32" data-testid="manifesto-section">
      <Reveal>
        <Overline>The manifesto</Overline>
        <h2 className="mt-4 max-w-3xl font-serif text-4xl font-bold tracking-tight sm:text-5xl">
          HOW A WALL BECOMES<br />A STANDARD<span className="text-accent">.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08} className="bg-background">
            <div className="group flex h-full flex-col p-8 transition-colors duration-300 hover:bg-card">
              <span className="font-mono text-sm font-bold text-accent">{s.n}</span>
              <h3 className="mt-6 font-serif text-xl font-semibold tracking-tight sm:text-2xl">
                {s.title}
              </h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-muted-foreground">
                {s.desc}
              </p>
              <span className="mt-8 block h-px w-10 bg-border transition-all duration-500 group-hover:w-full group-hover:bg-accent" />
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 grid grid-cols-2 gap-8 border-y border-border py-10">
        {STATS.map((s) => (
          <div key={s.label}>
            <p className="font-serif text-4xl font-black tracking-tight text-accent sm:text-5xl">{s.value}</p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              {s.label}
            </p>
          </div>
        ))}
      </Reveal>
    </section>
  );
}
